import { INCREMENT_TIME_COUNTER } from '../../actionTypes/timeCounter'

export const incrementTimeCounter = () => ({ type: INCREMENT_TIME_COUNTER })
